import { jsx as _jsx } from "react/jsx-runtime";
const LeftSideNavigation = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex gap-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex-1 min-w-0",
            children: children
        })
    });
};
export { LeftSideNavigation };
